import React from "react";
import { SERVER_IP, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import { HomeIcon } from "../../assets/Icons";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";

class CallStatistics extends React.Component {
  state = {
    list: [],
    message: "",
    next_btn: false,
    back_btn: 0,
    min_range: 0,
    max_range: 50,
    loading: false,
  };

  componentDidMount() {
    this.getData(0, 50);
  }

  /* ---------- Helpers ---------- */
  setTwoDigits = (d) => (d < 10 ? `0${d}` : d);

  /* ---------- API ---------- */
  getData = async (min_range, max_range) => {
    this.setState({ loading: true });

    const stored = sessionStorage.getItem("call_staistics");
    const other_id = stored ? JSON.parse(stored).to_user : 0;

    const headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    const payload = {
      user_id: ud.id,
      min_limit: min_range,
      max_limit: max_range,
      other_id,
    };

    try {
      const { data } = await axios.post(`${SERVER_IP}/calllogs`, payload, {
        withCredentials: true,
        headers,
      });

      if (!data.error) {
        const list = data.call_logs.map((log) => {
          const callerNames = log.Callers.map((c) => c.name).join(", ");
          // const created = new Date(log.Created_Datetime);

          // const dateTime = `${created.toLocaleDateString()} ${this.setTwoDigits(created.getHours())}:${this.setTwoDigits(created.getMinutes())}:${this.setTwoDigits(created.getSeconds())}`;

          return {
            ...log,
            name: callerNames,
            // displayDate: dateTime,
            displayDate: log.Created_Datetime,
            duration: log.Duration,
          };
        });

        this.setState({
          list,
          message: list.length ? "" : "No Record Found",
          next_btn: data.call_logs.length === 50,
          loading: false,
        });
      } else {
        auth_response_flow(data, (res) => {
          if (res.error === false && res.retry) {
            this.getData(min_range, max_range);
          } else {
            this.setState({ loading: false, message: "No Record Found" });
          }
        });
      }
    } catch (err) {
      swal("Something Went Wrong, Please Retry");
      this.setState({ loading: false, message: "No Record Found" });
    }
  };

  nextBtn = () => {
    const min = this.state.min_range + 50;
    const max = this.state.max_range + 50;
    this.setState({ back_btn: this.state.back_btn + 1, min_range: min, max_range: max }, () => this.getData(min, max));
  };

  backBtn = () => {
    if (this.state.back_btn === 0) return;
    const min = this.state.min_range - 50;
    const max = this.state.max_range - 50;
    this.setState({ back_btn: this.state.back_btn - 1, min_range: min, max_range: max }, () => this.getData(min, max));
  };

  render() {
    const { list, loading, message } = this.state;

    return (
      <div>
        <div className="xp-breadcrumbbar">
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <h3 className="xp-page-title">Call Logs</h3>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="xp-breadcrumb gradient-border">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <HomeIcon />
                    </a>
                  </li>
                  <li className="breadcrumb-item active">Call logs</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="xp-contentbar p-30 pt-3 pb-0">
          <div className="row">
            <div className="col-lg-12">
              <div className="card document_gradient_border padding-0">
                <div className="card-header border-radius-top-15">
                  <h5 className="card-title text-black">Call Logs</h5>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: 70 }}>S.No</th>
                          <th>Name</th>
                          <th style={{ width: 100 }}>Call Type</th>
                          <th style={{ width: 200 }}>Date/Time</th>
                          <th style={{ width: 200 }}>Duration (HH:MM:SS)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <TableSkelton rowCount={3} colCount={5} />
                        ) : list.length === 0 ? (
                          <tr>
                            <td colSpan={5} className="text-center">
                              <NoDataFound headText={message} />
                            </td>
                          </tr>
                        ) : (
                          list.map((row, idx) => (
                            <tr key={row.call_id ?? idx}>
                              <td>{idx + 1}</td>
                              <td>{row.name}</td>
                              <td className="text-center">
                                {row.call_type === "INCOMING" && row.call_status === "CONNECTED" && (
                                  <i className="mdi mdi-call-received" style={{ color: "green" }} />
                                )}
                                {row.call_type === "INCOMING" && row.call_status === "MISSEDCALL" && (
                                  <i className="mdi mdi-call-missed" style={{ color: "red" }} />
                                )}
                                {row.call_type === "INCOMING" && row.call_status === "DISCONNECTED" && (
                                  <i className="mdi mdi-call-received" style={{ color: "red" }} />
                                )}
                                {row.call_type === "OUTGOING" && row.call_status === "CONNECTED" && (
                                  <i className="mdi mdi-call-made" style={{ color: "green" }} />
                                )}
                                {row.call_type === "OUTGOING" && row.call_status === "DISCONNECTED" && (
                                  <i className="mdi mdi-call-made" style={{ color: "red" }} />
                                )}
                                {row.call_type === "ONGOING" && (
                                  <i className="mdi mdi-cellphone" style={{ color: "green" }} />
                                )}
                              </td>
                              <td>{row.displayDate}</td>
                              <td>{row.duration}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {list.length > 0 && (
                    <div className="body-footer mt-3">
                      <div className="text-right">
                        <button
                          className="btn btn-secondary mx-2"
                          onClick={this.backBtn}
                          disabled={this.state.back_btn === 0}
                          style={{borderRadius:'50px'}}
                        >
                          <i className="fa fa-angle-left" /> Prev
                        </button>
                        <button className="btn btn-primary" onClick={this.nextBtn} disabled={!this.state.next_btn}>
                          Next <i className="fa fa-angle-right" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CallStatistics;
